'use strict';

angular.module('export', [
    'ecrd',
    'event',
    'sharecrf-sdk',
    'user',
]);
